 //M10-12019
import React, { useState, useEffect } from "react";

interface DateTimeInputProps {
  label: string;
  value?: string; // ISO string
  onChange: (value: string) => void;
  min?: string; // ISO string for min date-time
  max?: string; // ISO string for max date-time
}

export const DateTimeInput: React.FC<DateTimeInputProps> = ({
  label,
  value,
  onChange,
  min,
  max,
}) => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("00:00");

  useEffect(() => {
  if (value) {
    console.log(value)
    const [datePart, timePart] = value.split("T");

    setDate(datePart || "");

    if (timePart) {
      const [hh, mm] = timePart.split(":");
      setTime(`${hh}:${mm}`);
    } else {
      setTime("00:00");
    }
  } else {
    setDate("");
    setTime("00:00");
  }
}, [value]);


  // Builds the ISO string by treating the picked date/time as literal UTC components — avoids the
  // browser's local timezone silently shifting the selected wall-clock time (e.g. IST) when converted.
  const buildIso = (datePart: string, timePart: string) => {
    const [y, m, d] = datePart.split("-").map(Number);
    const [hh, mm] = timePart.split(":").map(Number);
    return new Date(Date.UTC(y, m - 1, d, hh, mm, 0, 0)).toISOString();
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDate(e.target.value);
    if (e.target.value) {
      onChange(buildIso(e.target.value, time));
    }
  };

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTime(e.target.value);
    if (date) {
      onChange(buildIso(date, e.target.value));
    }
  };

  // min/max may be an unparseable placeholder (e.g. a blank "Invoice date" fallback of " ") —
  // new Date(...).toISOString() throws RangeError on an invalid date, so validate before formatting.
  const toDateOnly = (isoLike?: string) => {
    if (!isoLike) return undefined;
    const parsed = new Date(isoLike);
    return isNaN(parsed.getTime()) ? undefined : parsed.toISOString().split("T")[0];
  };

  const toTimeOnly = (isoLike?: string) => {
    if (!isoLike) return undefined;
    const parsed = new Date(isoLike);
    return isNaN(parsed.getTime()) ? undefined : parsed.toISOString().split("T")[1]?.slice(0, 5);
  };

  // When the picked date is the same as the max date, also cap the time so the
  // combined date+time can't land after the max instant (e.g. "now").
  const maxTime = date && date === toDateOnly(max) ? toTimeOnly(max) : undefined;

  return (
    <div className="flex items-center border border-gray-300 rounded-lg h-[33px] flex-1">
      <span className="px-3 text-gray-500 whitespace-nowrap">{label}{label ? ":" : ""}</span>
      <input
        type="date"
        className="flex-1 h-full px-2 bg-transparent text-gray-700 outline-none"
        value={date}
        onChange={handleDateChange}
        min={toDateOnly(min)}
        max={toDateOnly(max)}
      />
      <input
        type="time"
        className="w-[130px] h-full px-2 bg-transparent text-gray-700 outline-none"//M10-15728
        value={time}
        onChange={handleTimeChange}
        max={maxTime}
      />
    </div>
  );
};
 //M10-12019